import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SidebarItem } from '@/types';

interface SportsState {
  selectedSidebarItem: SidebarItem | null;
}

const initialState: SportsState = {
  selectedSidebarItem: null,
};

const sportsSlice = createSlice({
  name: 'sports',
  initialState,
  reducers: {
    setSelectedSidebarItem: (state, action: PayloadAction<SidebarItem | null>) => {
      state.selectedSidebarItem = action.payload;
    },
    resetSportsState: (state) => {
      state.selectedSidebarItem = null;
    },
  },
});

export const { setSelectedSidebarItem, resetSportsState } = sportsSlice.actions;

export const sportsReducer = sportsSlice.reducer;
